var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaveTeamIcon = function SvgLeaveTeamIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21158_16061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 16.6668C14.1641 14.6201 12.5049 12.9609 10.4582 12.9609H6.20323C4.15656 12.9609 2.4974 14.6201 2.4974 16.6668",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1693 10H18.3359",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 8.33301L18.3359 9.99967L16.6693 11.6663",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 10.4163C6.37733 10.4163 4.79167 8.83068 4.79167 6.87467C4.79167 4.91867 6.37733 3.33301 8.33333 3.33301C10.2893 3.33301 11.875 4.91867 11.875 6.87467C11.875 8.83068 10.2893 10.4163 8.33333 10.4163Z",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21158_16061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
};
export { SvgLeaveTeamIcon as ReactComponent };
export default __webpack_public_path__ + "leave-team-icon.svg";